import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageMeta } from '../utils/pageMeta';

const About = () => {
  const navigate = useNavigate();
  usePageMeta({ title: 'About Akedo | Free Web Games', path: '/about' });
  const buttonRef = useRef(null);
  const [spaceBelow, setSpaceBelow] = useState(0);

  useEffect(() => {
    function updateSpace() {
      if (buttonRef.current) {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const space = window.innerHeight - buttonRect.bottom;
        setSpaceBelow(space > 0 ? space : 0);
      }
    }
    updateSpace();
    window.addEventListener('resize', updateSpace);
    return () => window.removeEventListener('resize', updateSpace);
  }, []);

  useEffect(() => {
    // Recalculate after every render in case content changes
    function updateSpace() {
      if (buttonRef.current) {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const space = window.innerHeight - buttonRect.bottom - 202;
        setSpaceBelow(space > 0 ? space : 0);
      }
    }
    updateSpace();
  });

  return (
    <div className="about-page max-w-2xl mx-auto px-4 py-12 text-center">
      <h1 className="text-4xl font-bold mb-6 text-white">About Us</h1>
      <p className="mb-6 text-lg text-gray-200">
        Akedo is a free gaming platform built by gamers, for gamers.<br/>
        We believe in pure gameplay — no interruptions while you play, just games.
      </p>
      <h2 className="text-2xl font-semibold mb-2 mt-8 text-white">Our Mission</h2>
      <p className="mb-6 text-gray-200">
        To create a space where anyone can enjoy great games instantly, without distractions or paywalls.
      </p>
      <h2 className="text-2xl font-semibold mb-2 mt-8 text-white">What We Offer</h2>
      <ul className="mb-6 list-disc list-inside text-left inline-block text-gray-200">
        <li>No ads while you play</li>
        <li>A curated selection of fun, fast, and addictive games</li>
        <li>Instant play — no installs, no sign-ups</li>
        <li>Web-based, accessible anywhere</li>
      </ul>
      <h2 className="text-2xl font-semibold mb-2 mt-8 text-white">Who We Are</h2>
      <p className="mb-6 text-gray-200">
        Akedo was founded by a small team of game lovers who wanted something simple: real games, no nonsense.<br/>
        We're not a big studio or a faceless company — just people who love playing and sharing great games.
      </p>
      <h2 className="text-2xl font-semibold mb-2 mt-8 text-white">Why It Matters</h2>
      <p className="mb-10 text-gray-200">
        We’re building Akedo for the community — a platform that respects your time, skips the noise, and puts fun first.
      </p>
      <button
        ref={buttonRef}
        className="bg-[#00e5f3] hover:bg-[#001a5b] text-black hover:text-white font-bold py-3 px-8 rounded-full text-xl transition"
        onClick={() => navigate('/')}
      >
        PLAY NOW
      </button>
      <div style={{ height: spaceBelow }} />
    </div>
  );
};

export default About; 